import React, { Component, Fragment } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import authService from '../../services/AuthService';
import api, { apiResponseHandler, apiErrorHandler } from '../../services/AxiosService';
import { apiErrorPopup } from '../../helpers/MessagePopup';

class MetricsUsage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            numParentAccounts: 0,
            numClinicianAccounts: 0,
            totalAccounts: 0,
            totalRaters: 0,
            parentLogins: {},
            clinicianLogins: {},
            parentWon: {},
            parentLost: {},
            clinicianWon: {},
            clinicianLost: {}
        }

        this.itemDefs = [];
    }

    componentDidMount = () => {
        /*
         * Run a query to get the item information for the domain specified in props (null is all domains).
         * The query returns a list of definitions. 
         */
        let domainName = (this.state.domain == null || this.state.domain == "") ? "All" : this.state.domain;

        let url = "admin/accountmetrics";
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
        .then((response) => {
            if (response.status == 200) {
                this.setState({
                    numParentAccounts: response.data.numParentAccounts,
                    numClinicianAccounts: response.data.numClinicianAccounts,
                    totalAccounts: response.data.totalAccounts,
                    totalRaters: response.data.totalRaters,
                    parentLogins: response.data.parentLogins,
                    clinicianLogins: response.data.clinicianLogins,
                    parentWon: response.data.parentWon,
                    parentLost: response.data.parentLost,
                    clinicianWon: response.data.clinicianWon,
                    clinicianLost: response.data.clinicianLost
                });
            }
        })
        .catch(error => {
            // Major problem - should not happen.  Back to login?
            this.setState({ showErrorAlert: true });
            apiErrorPopup(apiErrorHandler(error));
        });
    }

    render() {
        const col1Width = 8;
        const col2Width = 4;
        return (

            
            <Fragment>
                <h4>Account Summary</h4>
                <Container fluid>
                    <Row>
                        <Col sm={3}>
                            <h4 className="metrics_heading">Active Accounts</h4>
                            <Row>
                                <Col sm={col1Width} className="metrics_indent0">Total Accounts</Col>
                                <Col sm={col2Width}>{this.state.totalAccounts}</Col>
                            </Row>
                            <Row>
                                <Col sm={col1Width} className="metrics_indent1">Clinicians</Col>
                                <Col sm={col2Width}>{this.state.numClinicianAccounts}</Col>
                            </Row>
                            <Row>
                                <Col sm={col1Width} className="metrics_indent1">Parents</Col>
                                <Col sm={col2Width}>{this.state.numParentAccounts}</Col>
                            </Row>
                            <Row>
                                <Col sm={col1Width} className="metrics_indent0">Total Raters</Col>
                                <Col sm={col2Width}>{this.state.totalRaters}</Col>
                            </Row>
                           
                        </Col>
                        <Col sm={4}>
                            <h4 className="metrics_heading" >New Accounts</h4>
                            <Table bordered size="sm">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>7 Days</th>
                                        <th>14 Days</th>
                                        <th>30 Days</th>
                                        <th>120 Days</th>
                                        <th>120+ Days</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Clinician</td>
                                        <td>{this.state.clinicianWon.numLast7}</td>
                                        <td>{this.state.clinicianWon.numLast14}</td>
                                        <td>{this.state.clinicianWon.numLast30}</td>
                                        <td>{this.state.clinicianWon.numLast120}</td>
                                        <td>{this.state.clinicianWon.numGreaterThan120}</td>
                                    </tr>
                                    <tr>
                                        <td>Parent</td>
                                        <td>{this.state.parentWon.numLast7}</td>
                                        <td>{this.state.parentWon.numLast14}</td>
                                        <td>{this.state.parentWon.numLast30}</td>
                                        <td>{this.state.parentWon.numLast120}</td>
                                        <td>{this.state.parentWon.numGreaterThan120}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                        <Col sm={4}>
                            <h4 className="metrics_heading">Logins</h4>
                            <Table bordered size="sm">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>7 Days</th>
                                        <th>14 Days</th>
                                        <th>30 Days</th>
                                        <th>120 Days</th>
                                        <th>120+ Days</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Clinician</td>
                                        <td>{this.state.clinicianLogins.numLast7}</td>
                                        <td>{this.state.clinicianLogins.numLast14}</td>
                                        <td>{this.state.clinicianLogins.numLast30}</td>
                                        <td>{this.state.clinicianLogins.numLast120}</td>
                                        <td>{this.state.clinicianLogins.numGreaterThan120}</td>
                                    </tr>
                                    <tr>
                                        <td>Parent</td>
                                        <td>{this.state.parentLogins.numLast7}</td>
                                        <td>{this.state.parentLogins.numLast14}</td>
                                        <td>{this.state.parentLogins.numLast30}</td>
                                        <td>{this.state.parentLogins.numLast120}</td>
                                        <td>{this.state.parentLogins.numGreaterThan120}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={3}>
                            
                        </Col>
                        <Col sm={4}>
                            <h4 className="metrics_heading">Lost Accounts</h4>
                            <Table bordered size="sm">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>7 Days</th>
                                        <th>14 Days</th>
                                        <th>30 Days</th>
                                        <th>120 Days</th>
                                        <th>120+ Days</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Clinician</td>
                                        <td>{this.state.clinicianLost.numLast7}</td>
                                        <td>{this.state.clinicianLost.numLast14}</td>
                                        <td>{this.state.clinicianLost.numLast30}</td>
                                        <td>{this.state.clinicianLost.numLast120}</td>
                                        <td>{this.state.clinicianLost.numGreaterThan120}</td>
                                    </tr>
                                    <tr>
                                        <td>Parent</td>
                                        <td>{this.state.parentLost.numLast7}</td>
                                        <td>{this.state.parentLost.numLast14}</td>
                                        <td>{this.state.parentLost.numLast30}</td>
                                        <td>{this.state.parentLost.numLast120}</td>
                                        <td>{this.state.parentLost.numGreaterThan120}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                        <Col sm={4}>
                            
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

export default MetricsUsage;


// WEBPACK FOOTER //
// ./src/components/AdminHome/metricsAccount.js